import { Skeleton, Typography } from '@mui/material'
import { useState } from 'react'
import styled from 'styled-components'

import navigate from '../core/navigate'
import { useBidProfileQuery } from '../core/queries'
import Dialog from './Dialog'

const Button = styled.button`
  border: none;
  background-color: unset;
  text-decoration: underline;
  text-decoration-color: #ccc;
  cursor: pointer;
`

const Anchor = styled.a`
  color: ${props => props.theme.palette.common.black};
  text-decoration-color: #ccc;
`

export default () => {
  const [open, setOpen] = useState(false)

  const { data: bidData, isLoading: isLoadingBidData } = useBidProfileQuery()

  const isBidEnabled = bidData?.statusId == 1 || bidData?.statusId == 13
  const isBidDisabledUpdatable = [3, 9, 11, 12].includes(bidData?.statusId)
  const bidStatusMessage = isBidEnabled ? (
    ''
  ) : (
    <>
      If you would like additional information regarding the status of&nbsp;
      your account, please contact us at&nbsp;
      <Anchor href='tel:18666089283'>1.866.608.9283</Anchor> for assistance.
    </>
  )

  const handleOpen = e => {
    e.preventDefault()
    if (isBidDisabledUpdatable) {
      navigate('/account/profile/billing')
    } else {
      setOpen(true)
    }
  }

  const handleClose = () => {
    setOpen(false)
  }

  const bidStatusHeader = (() => {
    switch (bidData?.statusId) {
      case 1:
        return 'Your account is authorized for bidding.'
      case 13:
        return 'We are currently reviewing your bank reference. Your account is authorized for bidding.'
      case 11:
        return 'Your credit card is invalid.'
      case 9:
        return 'We are currently reviewing your bank reference.'
      case 3:
        return 'Seller account. Bidding disabled.'
      case 12:
        return 'You currently have a Watchlist Only account. If you would like to bid, you will need to enter your credit/debit card or bank information to enable bidding.'
      case (6, 7, 8, 5, 10):
        return (
          <>
            Your account is disabled. Contact us at&nbsp;
            <Anchor href='tel:18666089283'>1.866.608.9283</Anchor> or&nbsp;
            <Anchor href='mailto:auction@purplewave.com'>
              auction@purplewave.com
            </Anchor>
            .
          </>
        )
      case 2:
        return 'Account disabled at customer request.'
      case 4:
        return (
          <>
            Duplicate account, contact us at&nbsp;
            <Anchor href='tel:18666089283'>1.866.608.9283</Anchor> or&nbsp;
            <Anchor href='mailto:auction@purplewave.com'>
              auction@purplewave.com
            </Anchor>
            .
          </>
        )
      default:
        return (
          <>
            Your account is disabled. Contact us at&nbsp;
            <Anchor href='tel:18666089283'>1.866.608.9283</Anchor> or&nbsp;
            <Anchor href='mailto:auction@purplewave.com'>
              auction@purplewave.com
            </Anchor>
            .
          </>
        )
    }
  })()
  return (
    <>
      <Button id='header_bid_status' onClick={handleOpen}>
        <span>Bidding: </span>
        <span>
          {!isLoadingBidData ? (
            isBidEnabled ? (
              <strong>Enabled</strong>
            ) : (
              <strong>Disabled</strong>
            )
          ) : (
            <Skeleton width={60} sx={{ display: 'inline-block' }} />
          )}
        </span>
      </Button>
      <Dialog
        title='Bidding Authorization'
        open={open}
        handleClose={handleClose}
        fullWidth={true}
        maxWidth='md'
      >
        <Typography variant='h3'>{bidStatusHeader}</Typography>
        <Typography>{bidStatusMessage}</Typography>
      </Dialog>
    </>
  )
}
